<template>
  <a-steps :current="current">
    <a-step :title="$t(`wizard.step1title`)"></a-step>
    <a-step :title="$t(`wizard.step2title`)"></a-step>
    <a-step :title="$t(`wizard.step3title`)"></a-step>
    <a-step :title="$t(`wizard.step4title`)"></a-step>
    <a-step :title="$t(`wizard.step5title`)"></a-step>
  </a-steps>
</template>

<script>
export default {
  name: 'wizard-steps',
  props: ['current'],
  computed: {
    // mobile: function() {
    //   return this.$mq.resize && this.$mq.below('960px');
    // }
  }
};
</script>

<style lang="scss">
// .wizard-steps-container {
//   padding: 1rem 1rem;
//   border-radius: 10px;
//   margin: 1rem 0;
// }

// .wizard-step-meta {
//   text-transform: uppercase;
//   letter-spacing: 1px;
//   font-size: 12px;
//   font-weight: 600;
// }

// .wizard-step-title {
//   font-weight: 900;
//   margin-bottom: 0px;
// }

// .wizard-step-subtitle {
//   font-size: 16px;
// }
</style>
